import { useReveal } from "../hooks/useReveal";
import { HomeHero } from "../components/home/HomeHero";
import { Offerings } from "../components/home/Offerings";
import { FeaturedWork } from "../components/home/FeaturedWork";
import { Connect } from "../components/home/Connect";
import { Seo } from "../components/Seo";

export default function Home() {
  const ref = useReveal();

  return (
    <div ref={ref} className="mp-paper min-h-screen" data-testid="home-page">
      <Seo page="home" />
      <HomeHero />
      <Offerings />
      <FeaturedWork />
      <Connect />
    </div>
  );
}
